import { useEffect, useState, createContext, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./site/Header";
import Footer from "./site/Footer";
import MobileBottomBar from "./site/MobileBottomBar";
import { DevisProvider } from "./site/DevisForm";
import api from "../lib/api";

const ConfigContext = createContext(null);
export const useConfig = () => useContext(ConfigContext);

export default function Layout() {
  const [config, setConfig] = useState(null);
  const location = useLocation();

  useEffect(() => {
    api.get("/site/config").then((res) => setConfig(res.data)).catch(() => {});
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ConfigContext.Provider value={config}>
      <DevisProvider>
        <div className="min-h-screen flex flex-col bg-white">
          <Header bandeau={config?.bandeau} fermeture={config?.fermeture} catalogueVisible={config?.catalogue_visible !== false} />
          <main className="flex-1">
            <Outlet />
          </main>
          <Footer catalogueVisible={config?.catalogue_visible !== false} />
          <MobileBottomBar />
        </div>
      </DevisProvider>
    </ConfigContext.Provider>
  );
}
